/**
 * Phone Input Component
 * Formats phone numbers as (XXX)XXX-XXXX
 */
import { Input } from "./input";
import { forwardRef } from "react";

// Format phone number to (XXX)XXX-XXXX
export const formatPhoneNumber = (value) => {
  if (!value) return "";
  
  // Remove all non-digit characters
  const phoneNumber = value.replace(/\D/g, "");
  
  // Format based on length
  if (phoneNumber.length === 0) return "";
  if (phoneNumber.length <= 3) return `(${phoneNumber}`;
  if (phoneNumber.length <= 6) return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(3)}`;
  return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

// Parse phone number to get just digits
export const parsePhoneNumber = (value) => {
  if (!value) return "";
  return value.replace(/\D/g, "").slice(0, 10);
};

export const PhoneInput = forwardRef(({ value, onChange, className, ...props }, ref) => {
  const handleChange = (e) => {
    const input = e.target.value;
    const digits = parsePhoneNumber(input);
    const formatted = formatPhoneNumber(digits);
    
    // Create a synthetic event with the formatted value
    onChange?.({
      ...e,
      target: {
        ...e.target,
        value: formatted
      }
    });
  };

  return (
    <Input
      ref={ref}
      type="tel"
      value={formatPhoneNumber(parsePhoneNumber(value))}
      onChange={handleChange}
      placeholder="(XXX)XXX-XXXX"
      className={className}
      {...props}
    />
  );
});

PhoneInput.displayName = "PhoneInput";

export default PhoneInput;
